import React from 'react';
import { ArrowUp } from 'lucide-react';
export function MetricCards() {
  const metrics = [{
    label: '3Ds created',
    value: '247',
    change: '18% this month',
    trend: 'up'
  }, {
    label: 'Upload rate',
    value: '31%',
    change: '4pts vs last mo.',
    trend: 'up'
  }, {
    label: 'Conversion lift',
    value: '+23%',
    change: 'patients with 3D',
    trend: 'neutral'
  }, {
    label: 'Avg ticket (3D)',
    value: '$4.8k',
    change: 'vs $3.9k no-3D',
    trend: 'up'
  }];
  return <div className="grid grid-cols-4 gap-6 mb-6" data-id="element-66">
      {metrics.map(metric => <div key={metric.label} className="bg-[#060c18] border border-[#0e1826] rounded-xl p-6 flex flex-col" data-id="element-67">
          <span className="text-sm font-medium text-[#3a5070] mb-3" data-id="element-68">
            {metric.label}
          </span>
          <span className="text-4xl font-bold text-[#f0ead8] mb-3" data-id="element-69">
            {metric.value}
          </span>
          <div className="flex items-center gap-1 mt-auto" data-id="element-70">
            {metric.trend === 'up' && <ArrowUp className="w-3.5 h-3.5 text-[#b8a06a]" data-id="element-71" />}
            <span className={`text-xs font-medium ${metric.trend === 'neutral' ? 'text-[#b8a06a]' : 'text-[#b8a06a]'}`} data-id="element-72">
              {metric.trend === 'up' ? '↑ ' : ''}
              {metric.change}
            </span>
          </div>
        </div>)}
    </div>;
}